"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = require("prop-types");
const xstate_1 = require("xstate");
const react_2 = require("@xstate/react");
const intl_1 = require("@kyruus/intl");
const forms_v2_1 = __importStar(require("@kyruus/forms-v2"));
const provider_components_1 = require("@kyruus/provider-components");
const formConfig_1 = __importDefault(require("./formConfig"));
const CancelationFailedBanner_1 = __importDefault(require("./CancelationFailedBanner"));
const styles_1 = require("./styles");
const messages_1 = __importDefault(require("../../lib/messages"));
const Tracking_1 = require("../../lib/constants/Tracking");
const utils_1 = require("../../lib/utils");
const xstate_2 = require("../../lib/constants/xstate");
const CancelPage = ({ service, track, intl }) => {
    const [state, send] = (0, react_2.useService)(service);
    const handleClick = (formData) => {
        const { email_consent = true, notes = '' } = formData.apptCancel || {};
        track(Tracking_1.userEvents.CLICK_CANCEL_APPT, {
            [Tracking_1.reasonGiven]: notes.trim().length > 0
        });
        send({
            type: xstate_2.events.cancel,
            data: {
                cancelEmailConsent: email_consent,
                cancelReasonText: notes
            }
        });
    };
    const { appointment, locationId, locations, provider } = state.context;
    // Sidebar adapter
    const appointmentQuery = {
        patientRel: appointment.patientRelationship,
        purpose: {
            name: appointment.patientPurpose
        }
    };
    const selectedAppointment = {
        start_datetime: appointment.startDateTime,
        location_id: locationId
    };
    const formFields = (0, react_1.useMemo)(() => (0, formConfig_1.default)(intl), [intl]);
    const { fields, addOns } = formFields;
    const providerPhone = (0, utils_1.hasProvider)(provider)
        ? (0, provider_components_1.getProviderContactPhone)(provider)
        : undefined;
    return (react_1.default.createElement("div", { "data-testid": "CancelPage" },
        react_1.default.createElement(styles_1.CancelHeading, null,
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.pageHeading))),
        react_1.default.createElement(styles_1.CancelContentContainer, null,
            react_1.default.createElement(styles_1.CancelTextContainer, null,
                react_1.default.createElement(styles_1.CancelFormWrapper, null,
                    react_1.default.createElement(forms_v2_1.default, { onSubmit: handleClick, fields: fields, submitButtonText: react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.cancelApptButton)) }, (0, forms_v2_1.getAddOns)(addOns)),
                    state.matches(`${xstate_2.states.cancelPage}.${xstate_2.states.cancelError}`) && (react_1.default.createElement(CancelationFailedBanner_1.default, { phone: providerPhone })))),
            (0, utils_1.hasProvider)(provider) && (react_1.default.createElement(styles_1.CancelSideBar, null,
                react_1.default.createElement(provider_components_1.ProviderSidebar, { provider: provider, locations: locations, appointmentQuery: appointmentQuery, selectedAppointment: selectedAppointment, track: track }))))));
};
CancelPage.propTypes = {
    service: (0, prop_types_1.instanceOf)(xstate_1.Interpreter).isRequired,
    track: prop_types_1.func.isRequired,
    intl: (0, prop_types_1.shape)({
        locale: prop_types_1.string.isRequired,
        formatMessage: prop_types_1.func.isRequired
    }).isRequired
};
CancelPage.defaultProps = {};
exports.default = (0, intl_1.injectIntl)(CancelPage);
//# sourceMappingURL=CancelPage.js.map